import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_PRODUCT_TYPE_REQUEST = 'GET_PRODUCT_TYPE_REQUEST';
export const GET_PRODUCT_TYPE_SUCCESS = 'GET_PRODUCT_TYPE_SUCCESS';
export const GET_PRODUCT_TYPE_FAILURE = 'GET_PRODUCT_TYPE_FAILURE';

const localStorageService = LocalStorage.getService();

export const getProductTypeRequest = () => {
    return {type: GET_PRODUCT_TYPE_REQUEST}
};

export const getProductTypeSuccess = (product_type = {}) => {
    return {type: GET_PRODUCT_TYPE_SUCCESS, product_type}
};

export const getProductTypeFailure = (error) => {
    return {type: GET_PRODUCT_TYPE_FAILURE, error}
};

export const startGetProductType = () => {
    console.log('Start startGetProductType');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getProductTypeRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/product_type/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response product_type search ", response.data);
                    dispatch(getProductTypeSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getProductTypeFailure(error));
            });
    };
};
